import React, { Component } from 'react';
import { Header, Icon, Image, Grid, Button } from 'semantic-ui-react'
import * as algoliasearch from 'algoliasearch';

class DesignChatFinalScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

   

   

    render() {

        const designApproved = this.props.match.params.clientChoice == 'approved'
            ? <Header as='h2' icon textAlign='center'>
                <Icon name='thumbs up' circular />
                <Header.Content>Thank you for approving your design!</Header.Content>
                <Header.Content>Pls note, for customized T-shirts & jumpers, we require a 50% deposit to begin the printing process. </Header.Content>
                <Header.Content>You can send to: 0757477399 - Rhoda Nalubega or 0778 086758 - Joseph Masendi </Header.Content>
                <Header.Content>You can call us on 0757477399 with any questions. or whatsapp us <a href="https://api.whatsapp.com/send?phone=256757477399&text=Hello%20Printboda">HERE</a> </Header.Content>
            </Header>
            : ''

        const designRejected = this.props.match.params.clientChoice == 'rejected'
            ? <Header as='h2' icon textAlign='center'>
                <Icon name='thumbs up' circular />
                <Header.Content>Thank you for your feedback!</Header.Content>
                <Header.Content>We will send you a message when the new design is ready</Header.Content>
                <Header.Content>You can call us on 0757477399 with any questions. or whatsapp us <a href="https://api.whatsapp.com/send?phone=256757477399&text=Hello%20Printboda">HERE</a> </Header.Content>
            </Header>
            : ''

        return (
            <div>

                <Grid
                    textAlign='center'
                    // style={{ height: '100%' }}
                    verticalAlign='middle' >
                    <Grid.Column style={{ maxWidth: 550 }}>
                        <Image src={require('../../../images/printboda_logo.png')} />

                        {designApproved}
                        {designRejected}

                    </Grid.Column>
                </Grid>



            </div>
        );
    }
}

export default DesignChatFinalScreen;


// WEBPACK FOOTER //
// ./src/components/newSite/DesignChat/DesignChatFinalScreen.js